


























































import Vue from "vue";
import { GET_MENU } from "@/queries/user/query.graphql";
import { mapGetters } from "vuex";
import { UPDATE_MENU } from "@/queries/user/mutation.graphql";

export default Vue.extend({
  data() {
    return {
      value: "dummy",
      img: null,
      show: true
    };
  },
  computed: {
    menuInfo(): any {
      return this.$store.getters["userModule/menuInfo"];
    }
  },
  methods: {
    updateInfo({ value, img }: { value?: string; img?: string }) {
      return this.$apollo.mutate({
        mutation: UPDATE_MENU,
        variables: {
          menuId: this.menuInfo.id,
          pdfUrl: this.menuInfo.pdfUrl,
          menuType: this.menuInfo.menuType,
          name: value,
          bannerUrl: img
        },
        update: (cache, { data: { update_Menu } }) => {
          if (update_Menu.affected_rows) {
            const data: any = cache.readQuery({
              query: GET_MENU
            });
            data.Menu[0].name = value;
            data.Menu[0].bannerUrl = img;
            cache.writeQuery({
              query: GET_MENU,
              data
            });
          }
        }
      });
    },
    editName(value: string, close) {
      const trimed = value.trim();
      if (trimed.length === 0) {
        this.$toastr.e("You should insert one character at list!");
        return;
      }
      this.updateInfo({ value, img: this.menuInfo.bannerUrl })
        .then(data => {
          this.$toastr.s("Updated successfuly");
          close();
        })
        .catch(error => {
          this.$toastr.e("error");
        });
    },
    closeInput({ reason }, close) {
      if (reason === "outside") {
        return;
      }
      close();
    },
    upload(img: string) {
      this.updateInfo({ img, value: this.menuInfo.name }).then(data => {
        this.$toastr.s("Updated successfuly");
        this.menuInfo.bannerUrl = img;
      });
    },
    replace(img: string) {
      this.updateInfo({ img, value: this.menuInfo.name }).then(data => {
        this.$toastr.s("Updated successfuly");
        this.menuInfo.bannerUrl = img;
      });
    },
    remove() {
      this.updateInfo({ img: "", value: this.menuInfo.name }).then(data => {
        this.$toastr.s("Updated successfuly");
        this.menuInfo.bannerUrl = "";
      });
    }
  }
});
